import { createSlice } from '@reduxjs/toolkit';
import { GLOBAL } from '../constants';
import initialState from '../initialStates/global';

const slice = createSlice({
  name: GLOBAL,
  initialState: initialState,
  reducers: {
    setJWT(state, action) {
      const { JWT } = action.payload;
      state.JWT = JWT;
    },
    setEmail(state, action) {
      const { email } = action.payload;
      state.email = email;
    },
    setPreviousPage(state, action) {
      const { previousPage } = action.payload;
      state.previousPage = previousPage;
    },
  },
});

const globalReducer = {
  [GLOBAL]: slice.reducer,
};

export const { setJWT, setEmail, setPreviousPage } = slice.actions;
export default globalReducer;
